/**
 * 分销团队审核外挂（/supervisorAudit）· 登录态存取
 *
 * 为什么单独一套 key：本页与推荐官购买页同域（h5.scrmai.com），localStorage 共用，
 * 购买页的 `token` 是微信授权态凭据，两者不能混用，否则会互相顶掉。
 */
const TOKEN_KEY = 'SUPERVISOR_AUDIT_TOKEN'
const EXPIRE_AT_KEY = 'SUPERVISOR_AUDIT_EXPIRE_AT'
const TEAM_KEY = 'SUPERVISOR_AUDIT_TEAM'

/**
 * 保存登录态与团队信息
 * @param {string} token 后端签发的 token
 * @param {number} expireAt 过期时间（毫秒时间戳）
 * @param {Object} team 团队信息（团队名 / 企业名），用于页头展示
 */
export function saveLogin(token, expireAt, team) {
  localStorage.setItem(TOKEN_KEY, token)
  localStorage.setItem(EXPIRE_AT_KEY, String(expireAt || 0))
  localStorage.setItem(TEAM_KEY, JSON.stringify(team || {}))
}

/**
 * 读取 token（不判断是否过期）
 * @returns {string|null} token
 */
export function getToken() {
  return localStorage.getItem(TOKEN_KEY)
}

/**
 * 读取缓存的团队信息
 * @returns {Object} 团队信息（可能为空对象）
 */
export function getTeam() {
  try {
    return JSON.parse(localStorage.getItem(TEAM_KEY) || '{}')
  } catch (error) {
    return {}
  }
}

/**
 * 清掉登录态
 */
export function clearToken() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(EXPIRE_AT_KEY)
  localStorage.removeItem(TEAM_KEY)
}

/**
 * 是否处于有效登录态（本地有 token 且未到过期时间）
 * @returns {boolean} true 已登录
 */
export function isLoggedIn() {
  if (!getToken()) {
    return false
  }
  const expireAt = Number(localStorage.getItem(EXPIRE_AT_KEY))
  if (!expireAt || expireAt <= Date.now()) {
    clearToken()
    return false
  }
  return true
}
